import Typography from 'components/global/Typography';

import * as S from './CurrencyViewer.styled';

const CurrencyConfig = {
	dcFee: { sign: '-' },
	otoFee: { sign: '-' },
	creditPurchase: { sign: '+' },
	creditDCPurchase: { sign: '+' },
	creditBankTransfer: { sign: '+' },
	referrals: { sign: '+' },
	referral: { sign: '+' },
	freeCredit: { sign: '+' },
	registerPromoCodeFreeCredit: { sign: '+' },
	chargeBack: { sign: '+' },
	extraCorrectionCharge: { sign: '-' },
	watchingVideoReward: { sign: '+' },
	bankTransfer: { sign: '+' },
	watchingVideo: { sign: '+' },
	increaseV2Credit: { sign: '+' },
	decreaseV2Credit: { sign: '-' },
	creditPurchaseExtraCredit: { sign: '+' },
	creditBankTransferExtraCredit: { sign: '+' }
};

const FreeShipmentCreditConfig = {
	otoFeeFreeShipmentDeliveredDescription: { sign: '-' },
	otoFeeFreeShipmentDeliveredDescriptionEnterprise: { sign: '-' },
	otoFeeFreeShipmentSearchingDriverDescription: { sign: '-' },
	otoFeeFreeShipmentSearchingDriverDescriptionEnterprise: { sign: '-' },
	otoFeeFreeShipmentReturnedDescription: { sign: '-' },
	otoFeeFreeShipmentReturnedDescriptionEnterprise: { sign: '-' },
	otoFeeFreeShipmentReturnShipmentProcessingDescription: { sign: '-' },
	otoFeeFreeShipmentReturnShipmentProcessingDescriptionEnterprise: { sign: '-' },
	otoFeeFreeShipmentCanceledRevokedDescription: { sign: '-' },
	otoFeeFreeShipmentCanceledRevokedDescriptionEnterprise: { sign: '-' },
	otoFeeFreeShipmentReverseShipmentCanceledDescription: { sign: '+' },
	otoFeeFreeShipmentReverseShipmentCanceledDescriptionEnterprise: { sign: '+' },
	otoFeeFreeShipmentCanceledDescription: { sign: '+' },
	otoFeeFreeShipmentCanceledDescriptionEnterprise: { sign: '+' },
	otoFeeFreeShipmentReturnedCompletedDescription: { sign: '+' },
	otoFeeFreeShipmentReturnedCompletedDescriptionEnterprise: { sign: '+' },
	otoFeeFreeShipmentReverseShipmentCanceledRevokedDescription: { sign: '+' },
	otoFeeFreeShipmentReverseShipmentCanceledRevokedDescriptionEnterprise: { sign: '+' }
};

const defaultConfig = { sign: '' };

const CurrencyViewerColored = ({ data, value }) => {
	let config = CurrencyConfig[data.transactionType] || defaultConfig;

	if (data.status === 'canceled') {
		config = { sign: '+' };
	}

	if (data.status === 'deducted') {
		config = { sign: '-' };
	}

	if (data.status === 'refunded') {
		if (
			data.description === 'dcFeeReturnedExtraFeeDescription' ||
			data.description === 'dcFeeReturnedIncludingCODExtraFeeDescription'
		) {
			config = { sign: '-' };
		} else {
			config = { sign: '+' };
		}
	}

	if (data.transactionType === 'dcFee') {
		if (data.description === 'bulletAggregatorSuccessfulRefundDescription') {
			config = { sign: '+' };
		}
		if (data.description === 'bulletAggregatorDownPaymentDescription') {
			config = { sign: '-' };
		}
		if (
			data.description === 'dcFeeReturnedDescription' ||
			data.description === 'dcFeeReturnedIncludingCODDescription'
		) {
			config = { sign: '+' };
		}
	}

	if (data.transactionType === 'otoFee') {
		if (data.description === 'otoFeeReturnedDescription') {
			config = { sign: '+' };
		}
	}

	const isFreeShipmentCredit =
		data.transactionType === 'freeShipmentCredit' ||
		data.transactionType === 'freeShipmentCreditUpdate' ||
		data.transactionType === 'otoFeeFreeShipment' ||
		data.transactionType === 'otoFeeFreeShipmentEnterprise';

	if (isFreeShipmentCredit) {
		config = FreeShipmentCreditConfig[data.description] || config;
	}

	return (
		<S.CurrencyContainer>
			<Typography color={config.sign === '+' ? 'var(--green-hover)' : 'var(--red)'} fontWeight="500">
				{config.sign}
			</Typography>
			<Typography
				color={config.sign === '-' ? 'var(--red)' : config.sign === '+' ? 'var(--green-hover)' : 'var(--black)'}
				withCurrency={!isFreeShipmentCredit}
				currency={data?.currency}
				fontWeight="500">
				{value}
			</Typography>

			{isFreeShipmentCredit && (
				<>
					<Typography>&nbsp;</Typography>
					<Typography
						color={
							config.sign === '-'
								? 'var(--red)'
								: config.sign === '+'
									? 'var(--green-hover)'
									: 'var(--black)'
						}
						fontWeight="500">
						shipments
					</Typography>
				</>
			)}
		</S.CurrencyContainer>
	);
};

export default CurrencyViewerColored;
